import { useEffect } from 'react';
import { ContentLoaderProps } from './types';

/**
 * The purpose of this component is to pass the newly create topic to the parent component
 * @param param0 // all the properties available from the create topic response
 * @returns // returns a React fragment because there is nothing to render
 */
const ContentLoader = ({
  contentThreadId,
  contentId,
  title,
  dateShared,
  dateModified,
  modifiedBy,
  tags,
  onLoad,
}: ContentLoaderProps) => {
  useEffect(() => {
    // Simply call the onLoad prop when the component mounts to pass the content to parent component
    const content = {
      contentThreadId,
      contentId,
      title,
      dateShared,
      dateModified,
      modifiedBy,
      tags,
    };
    onLoad(content);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default ContentLoader;
